
import React, { useEffect, useState } from "react";
import Accordion from "./common/Accordion";
import InputFieldControl from "./common/InputFieldControl";
import Cookies from "js-cookie";
import toast from "react-hot-toast";

const MuviOwnershipForm = ({
  customerDetails,
  editPermissions,
  usersList = [],
  refreshCustomerDetails = () => { },
}) => {
  const [ConfirmationModalOpen, setConfirmationModalOpen] = useState(false);

  const [tseOwnerList, setTseOwnerList] = useState([]);
  const [salesManagerList, setSalesManagerList] = useState([]);
  const [accountManagerList, setAccountManagerList] = useState([]);

  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [activeUsersList, setActiveUsersList] = useState([]);

  const [formData, setFormData] = useState({
    account_manager: "",
    tse_owner: "",
    sales_manager: "",
    customer_id: "",
  });

  useEffect(() => {
  if (!usersList || Object.keys(usersList).length === 0) return;

  const activeUsers = Object.values(usersList)
    .filter((user) => Number(user.is_active) === 1)
    .map((user) => ({
      value: user.name,
      id: user.user_uuid,
    }));

  setActiveUsersList(activeUsers);
}, [usersList]);


  useEffect(() => {
    if (customerDetails) {
      fetchFromData();
    }
  }, [customerDetails]);

  const fetchFromData = () => {
    setFormData({
      ...formData,
      account_manager: customerDetails.account_manager || "",
      tse_owner: customerDetails.tse_owner || "",
      sales_manager: customerDetails.sales_manager || "",
      customer_id: customerDetails.appToken || "",
      email: customerDetails.email || "",
      mautic_id: customerDetails.mautic_id || "",
    });
  };

  // useEffect(() => {
  //   getOwnerShipEmails("tse_owner");
  //   getOwnerShipEmails("sales_manager");
  //   getOwnerShipEmails("account_manager");
  // }, []);

  const getOwnerShipEmails = async (type) => {
    let email = "";

    if (type == "tse_owner") {
      email = "support@muvi.com";
    } else if (type == "sales_manager") {
      email = "sales@muvi.com";
    } else if (type == "account_manager") {
      email = "accountmanagement@muvi.com";
    } else {
      return;
    }

    const resp = await fetch(
      `${process.env.REACT_APP_OWNERSHIP_URL}?email=${email}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = await resp.json();
    const formattedData = data.data
      .map((email) => {
        if (email.user_uuid) {
          return {
            value: email.name,
            id: email.user_uuid,
          };
        }
        return null;
      })
      .filter(Boolean);

    console.log("Formatted Data for", type, ":", formattedData);

    if (type == "tse_owner") {
      setTseOwnerList(formattedData);
    } else if (type == "sales_manager") {
      setSalesManagerList(formattedData);
    } else if (type == "account_manager") {
      setAccountManagerList(formattedData);
    }
  };

  const handleInputChange = (valueFor, value) => {
    console.log("Value for:", valueFor, "Value:", value);

    setFormData((prevData) => ({
      ...prevData,
      [valueFor]: value,
    }));
  };

  const onEditClick = () => {
    setIsEditing(true);
  };

  // const onSaveClick = () => {
  //   setConfirmationModalOpen(true);
  // };

  const storeLead = async (data) => {
    console.log("Storing lead with data:", data);
    try {
      setIsLoading(true);

      const response = await fetch(
        process.env.REACT_APP_CRM + "/muvi6/manage-muvi-ownership",
        {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      const res = await response.json();

      if (!res || res.code != 200) {
        toast.error(
          "An error occurred while processing your request. Please try again!"
        );
        setIsLoading(false);
        return {
          success: false,
          message: "Failed to create lead",
          code: res.code || 500,
        };
      }

      toast.success("Lead Updated successfully!");
      return {
        success: true,
        message: "Lead Updated successfully",
        code: res.code || 200,
      };
    } catch (error) {
      console.error("Error saving lead:", error);
      toast.error(
        "An error occurred while processing your request. Please try again!"
      );

      return {
        success: false,
        message: "An unexpected error occurred",
        code: 500,
      };
    } finally {
      setIsLoading(false);
    }
  };

  const handleContactInfoSave = async () => {
    setConfirmationModalOpen(false);
    const userUUID = Cookies.get("muvi_useruuid");

    await storeLead({
      ...formData,
      product_key: "3D28C83C85544F0D9517DD2E7C7EEDAA",
      user_uuid: userUUID,
      account_manager: formData.account_manager || "",
      tse_owner: formData.tse_owner || "",
      sales_manager: formData.sales_manager || "",
    });
    await refreshCustomerDetails();

    setIsEditing(false);
  };

  const handleCancelEdit = () => {
    fetchFromData();
    setIsEditing(false);
  };

  const ActionButton = () => {
    if (isLoading) {
      return (
        <button className="editprimary-btn editsecondry-btn" disabled>
          Loading...
        </button>
      );
    }

    return (
      <React.Fragment>
        <button
          className="editprimary-btn editsecondry-btn"
          onClick={(e) => {
            e.stopPropagation();
            if (isEditing) {
              handleContactInfoSave();
              // onSaveClick();
            } else {
              onEditClick();
            }
          }}
        >
          {!isEditing && (
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
              >
                <g clip-path="url(#clip0_501_8376)">
                  <path
                    d="M8.5 1.5C8.63132 1.36868 8.78722 1.26451 8.9588 1.19344C9.13038 1.12236 9.31428 1.08578 9.5 1.08578C9.68572 1.08578 9.86962 1.12236 10.0412 1.19344C10.2128 1.26451 10.3687 1.36868 10.5 1.5C10.6313 1.63132 10.7355 1.78722 10.8066 1.9588C10.8776 2.13038 10.9142 2.31428 10.9142 2.5C10.9142 2.68572 10.8776 2.86961 10.8066 3.04119C10.7355 3.21277 10.6313 3.36868 10.5 3.5L3.75 10.25L1 11L1.75 8.25L8.5 1.5Z"
                    stroke="#006EFA"
                    stroke-width="1.33"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_501_8376">
                    <rect width="12" height="12" fill="white"></rect>
                  </clipPath>
                </defs>
              </svg>
            </span>
          )}
          {isEditing ? "Save" : "Edit"}
        </button>
        {isEditing && (
          <button
            className="editprimary-btn editsecondry-btn"
            onClick={(e) => {
              e.stopPropagation();
              handleCancelEdit();
            }}
          >
            {"Cancel"}
          </button>
        )}
      </React.Fragment>
    );
  };

  return (
    <Accordion
      header="Muvi Ownership"
      targetID="muviOwnershipForm"
      actionButton={editPermissions && <ActionButton />}
      overrideOpenState={isEditing ? true : null}
    >
      <div class="form-customer-details">
        <div class="customer-info">
          <InputFieldControl
            fieldName="account_manager"
            label="Account Manager"
            type={"select"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            data={activeUsersList || []}
            isLoading={isLoading}
          />
          <InputFieldControl
            fieldName="tse_owner"
            label="TSE Owner"
            type={"select"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            data={activeUsersList || []}
            isLoading={isLoading}
          />
          <InputFieldControl
            fieldName="sales_manager"
            label="Sales Manager"
            type={"select"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            data={activeUsersList || []}
            isLoading={isLoading}
          />
        </div>
      </div>
      {/* <ConfirmationModal
        text={"Are you sure you want to save the changes?"}
        showModal={ConfirmationModalOpen}
        setShowModal={setConfirmationModalOpen}
        onConfirm={handleContactInfoSave}
      /> */}
    </Accordion>
  );
};

export default MuviOwnershipForm;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/MuviOwnershipForm.js